import { Typography } from "antd";
import { ComponentPropsWithoutRef, ReactNode } from "react";
import { Merge } from "type-fest";

import { useRouter } from "@sol/routing";
import { ArrowLeft } from "@sol/uikit/core/icons";
import Button from "@sol/uikit/general/Button";

import { AuthenticatedLayoutContent, AuthenticatedLayoutHeader } from "./AuthenticatedLayout";

export type PageLayoutProps = Merge<
    ComponentPropsWithoutRef<typeof AuthenticatedLayoutContent>,
    {
        title?: ReactNode;
        showBackButton?: boolean;
        headerActions?: ReactNode;
        onBackClick?: () => void;
    }
>;

export function PageLayout({ title, children, showBackButton, headerActions, onBackClick, ...props }: PageLayoutProps) {
    const { canGoBack, goBack } = useRouter();

    return (
        <>
            {title || headerActions ? (
                <AuthenticatedLayoutHeader>
                    <div className="flex items-center gap-2">
                        {showBackButton && canGoBack && (
                            <Button
                                onClick={() => (onBackClick ?? goBack)()}
                                className="
                               size-8 items-center justify-center border border-[--ant-color-border] text-[--ant-color-primary]"
                            >
                                <ArrowLeft size={16} />
                            </Button>
                        )}
                        <div className="flex w-full items-center gap-ant-sm">
                            {title && (
                                <Typography.Title level={1} className="!mb-0" ellipsis={{ rows: 1, tooltip: true }}>
                                    {title}
                                </Typography.Title>
                            )}
                            {headerActions}
                        </div>
                    </div>
                </AuthenticatedLayoutHeader>
            ) : null}
            <AuthenticatedLayoutContent {...props}>{children}</AuthenticatedLayoutContent>
        </>
    );
}
